import { Box, Button, Stack } from '@mui/material';
import { useMediaList, MediaList } from 'entities/media/media-list';
import { useDeleteMedia } from 'features/media/delete';
import { MediaListFilter } from 'features/media/media-filter';
import { useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { usePagingParams } from 'shared/hooks/paging-params';
import AddIcon from '@mui/icons-material/Add';
import { CompanyMediaAttachDialog } from 'features/company/media';

export const CompanyMedia = ({ companyId, isSupplier }: {companyId: number; isSupplier?: boolean}) => {
  const [paging, setPaging] = usePagingParams();
  const [searchParams] = useSearchParams();
  const [attachDialogOpen, setAttachDialogOpen] = useState(false);
      
  searchParams.set('companyId', companyId.toString());
    
  const getMediaRelatedSearchParams = useMemo(() => {
    const relatedFields = ['title', 'cityId', 'mediaTypeId', 'regionId', 'countryId','hierarchy', 'withPrices', 'placement', 'companyId'];
    const newParams = new URLSearchParams();
    [...searchParams.entries()].forEach(([key, value]) => {
      if (relatedFields.includes(key)) {
        newParams.append(key, value);
      }
    });
    return newParams;
  }, [searchParams]);
    
  const collection = useMediaList(paging, getMediaRelatedSearchParams);
    
  const deleteMedia = useDeleteMedia();
  return (
    <Box mt={2}>
      <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between" mb={1}>
        <MediaListFilter withNameSearch={true} withPricesFilter={false}/>
        {isSupplier && (
          <Button variant="contained" startIcon={<AddIcon />} onClick={() => setAttachDialogOpen(true)}>
            Прикрепить СМИ
          </Button>
        )}
      </Stack>
        
      <MediaList collection={collection} paging={paging} onChangePaging={setPaging} onMediaDeleteClick={deleteMedia} readonly/>

      {isSupplier && (
        <CompanyMediaAttachDialog open={attachDialogOpen} companyId={companyId} onClose={() => setAttachDialogOpen(false)} />
      )}
        
    </Box>
  );
};
